import React from "react";

const NotFound = () => {
  window.location.href = "https://www.peakjobs.app/";

  return <div className="NotFound"></div>;
};

export default NotFound;
